export function isHello(cloudId: string): boolean {
	return cloudId === 'a436116f-02ce-4520-8fbb-7301462a1674';
}
